import React from "react";
import { Link } from "react-router-dom";
import { GsdReadableBlock } from "@/coquille-bridge";
import { useKarateUi } from "@/hooks/useKarateUi.js";
import {
  OFFICIAL_LIST_TEMPLATE_PUBLIC_PATH,
  OFFICIAL_LIST_REQUIRED_COLUMNS,
  OFFICIAL_LIST_ALLOWED_VALUES,
} from "@/config/officialListTemplate055.js";

export function AdminOfficialListPrepPanel() {
  const { ui } = useKarateUi();
  const ol = ui.officialListPrep;

  return (
    <div className="official-list-prep-panel" data-testid="admin-official-list-prep-panel">
      <GsdReadableBlock variant="warning" testId="official-list-no-invent-notice">
        {ol.noInventNotice}
      </GsdReadableBlock>

      <GsdReadableBlock variant="info" testId="official-list-bulk-disabled-notice">
        {ol.bulkImportDisabled}
      </GsdReadableBlock>

      <p className="official-list-prep-intro">{ol.intro}</p>

      <section className="official-list-prep-section">
        <h3>{ol.templateTitle}</h3>
        <p>{ol.templateDescription}</p>
        <a
          href={OFFICIAL_LIST_TEMPLATE_PUBLIC_PATH}
          download
          className="btn-secondary"
          data-testid="official-list-template-download"
        >
          {ol.downloadTemplate}
        </a>
      </section>

      <section className="official-list-prep-section">
        <h3>{ol.requiredFieldsTitle}</h3>
        <ul data-testid="official-list-required-columns">
          {OFFICIAL_LIST_REQUIRED_COLUMNS.map((col) => (
            <li key={col}>{ol.columns[col] || col}</li>
          ))}
        </ul>
      </section>

      <section className="official-list-prep-section">
        <h3>{ol.allowedValuesTitle}</h3>
        <dl className="official-list-allowed-values" data-testid="official-list-allowed-values">
          {Object.entries(OFFICIAL_LIST_ALLOWED_VALUES).map(([field, values]) => (
            <div key={field}>
              <dt>{ol.columns[field] || field}</dt>
              <dd>{values.join(", ")}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="official-list-prep-section">
        <h3>{ol.comptesLinkTitle}</h3>
        <p>{ol.comptesLinkDescription}</p>
        <Link to="/admin/comptes" className="btn-primary" data-testid="official-list-link-comptes">
          {ol.comptesLinkCta}
        </Link>
      </section>

      <section className="official-list-prep-section">
        <h3>{ol.blackDragonTitle}</h3>
        <p data-testid="official-list-black-dragon-notice">{ol.blackDragonNotice}</p>
      </section>
    </div>
  );
}
